(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cg-angebot"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cg-offer]').forEach((offer) => {
    const options = Array.from(offer.querySelectorAll('[data-cg-option]'));
    const quantityInput = offer.querySelector('[data-cg-quantity-input]');
    const propertyInput = offer.querySelector('[data-cg-property-input]');

    const selectOption = (option) => {
      options.forEach((item) => {
        const selected = item === option;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-checked', selected ? 'true' : 'false');
      });

      quantityInput.value = option.dataset.cgQuantity;
      propertyInput.value = option.dataset.cgLabel;
      window.dispatchEvent(new CustomEvent('cg:bundlechange', {
        detail: {
          label: option.dataset.cgLabel,
          price: option.dataset.cgPrice,
          quantity: option.dataset.cgQuantity
        }
      }));
    };

    options.forEach((option) => option.addEventListener('click', () => selectOption(option)));
    const selected = options.find((option) => option.classList.contains('is-selected'));
    if (selected) selectOption(selected);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-hauptbild-kaufbox"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cg-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-cg-track]');
    const slides = Array.from(gallery.querySelectorAll('[data-cg-slide]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-cg-thumb]'));

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = Number(thumb.dataset.cgThumb);
        slides[index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
    });

    track?.addEventListener('scroll', () => {
      const index = Math.round(track.scrollLeft / track.clientWidth);
      thumbs.forEach((thumb, thumbIndex) => thumb.classList.toggle('is-active', thumbIndex === index));
    }, { passive: true });
  });

  document.querySelectorAll('[data-cg-hero]').forEach((hero) => {
    const dialog = hero.querySelector('[data-cg-dialog]');
    const dialogImage = hero.querySelector('[data-cg-dialog-image]');
    hero.querySelectorAll('[data-cg-slide]').forEach((slide) => {
      slide.addEventListener('click', () => {
        dialogImage.src = slide.dataset.cgFull;
        dialog.showModal();
      });
    });
    hero.querySelector('[data-cg-close]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-mobile-kaufleiste"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cg-sticky-buy]').forEach((bar) => {
    const label = bar.querySelector('[data-cg-sticky-label]');
    const price = bar.querySelector('[data-cg-sticky-price]');
    const quantity = bar.querySelector('[data-cg-sticky-quantity]');
    const property = bar.querySelector('[data-cg-sticky-property]');

    window.addEventListener('cg:bundlechange', (event) => {
      label.textContent = event.detail.label;
      price.textContent = event.detail.price;
      quantity.value = event.detail.quantity;
      property.value = event.detail.label;
    });

    const isVisible = (element) => {
      if (!element || element === bar || bar.contains(element)) return false;
      const style = window.getComputedStyle(element);
      const rect = element.getBoundingClientRect();
      return style.display !== 'none' && style.visibility !== 'hidden' && rect.height > 40 && rect.bottom > window.innerHeight - 160;
    };

    const updateForCookieBanner = () => {
      const selectors = [
        '[id*="cookie" i]',
        '[class*="cookie" i]',
        '[id*="consent" i]',
        '[class*="consent" i]'
      ];
      const bannerVisible = selectors.some((selector) => Array.from(document.querySelectorAll(selector)).some(isVisible));
      bar.classList.toggle('is-hidden', bannerVisible);
    };

    updateForCookieBanner();
    window.addEventListener('resize', updateForCookieBanner, { passive: true });
    new MutationObserver(updateForCookieBanner).observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cg-videos-ohne-ton"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cg-videos]').forEach((section) => {
    const videos = Array.from(section.querySelectorAll('[data-cg-video]'));

    const enforceSilence = (video) => {
      video.defaultMuted = true;
      video.muted = true;
      video.volume = 0;
      video.removeAttribute('controls');
    };

    const loadVideo = (video) => {
      if (video.dataset.cgLoaded === 'true') return;
      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
      });
      video.dataset.cgLoaded = 'true';
      enforceSilence(video);
      video.load();
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        enforceSilence(video);
        if (entry.isIntersecting) {
          loadVideo(video);
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }, { rootMargin: '240px 0px', threshold: 0.15 });

    videos.forEach((video) => {
      enforceSilence(video);
      video.addEventListener('volumechange', () => enforceSilence(video));
      observer.observe(video);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
